<template>
  <div class="chooseItem" id="step-4" v-if="hasSize">
    <div class="wrap">
      <div class="title-wrap">
        <p class="fs-36 color-black bold">
          {{ blockTitle }}
        </p>
        <button
          v-if="isCompleted"
          class="btn btn-link"
          @click="reset"
        >
          {{ trans.change }}
        </button>
      </div>

      <collapse-transition :duration="800">
        <div v-if="isActive && !isCompleted">
          <ul class="checkbox-list size-wrap">
            <li
              v-for="size in preselected.size.list"
              :key="size.id"
              :class="sizeOptionClass(size)"
              class="checkboxEl"
              @click="selectSize(size)"
            >
              <div class="stripe"/>
              <p class="titleSize">{{ size.title }}</p>
              <p class="textSize">{{ trans[size.description] }}</p>
            </li>
          </ul>

          <p class="fs-11 color-gray mb-40">
            {{ trans['size_recommendation'] }} {{ trans['please_check'] }}}
            <a href="#geometry-table" @click.prevent="scrollToGeometry">
              {{ trans['geometry_table'] }}
            </a> {{ trans['for_details'] }}
          </p>

          <button
            :class="confirmBtnClass"
            :disabled="isDisabled"
            class="btn btn-green"
            type="button"
            @click="confirmSelected()"
          >
            {{ trans.confirm }}
          </button>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {CollapseTransition} from "@ivanv/vue-collapse-transition";

export default {
  name: "BuildSizeSelector",
  props: {
    trans: {
      required: true
    }
  },
  components: {
    'collapse-transition': CollapseTransition
  },
  computed: {
    ...mapGetters({
      steps: 'build/stepList',
      loading: 'build/selectorLoading',
      preselected: 'build/preselected',
    }),
    selectedTitle() {
      return this.preselected?.title?.selected || null
    },
    selectedModel() {
      return this.preselected?.model?.selected || null
    },
    selectedColor() {
      return this.preselected?.color?.selected || null
    },
    selectedSize() {
      return this.preselected?.size?.selected || null
    },
    hasSize() {
      return this.preselected && this.preselected.size
    },
    isCompleted() {
      return this.hasSize && this.preselected.size.completed
    },
    isActive() {
      return this.hasSize && this.preselected.size.active
    },
    isDisabled() {
      return !this.hasSize || this.preselected.size.selected === null || this.loading
    },
    confirmBtnClass() {
      return {
        disabled: this.isDisabled
      }
    },
    blockTitle() {
      if (this.isCompleted) {
        return this.preselected.size.selected.title
      }

      return this.trans['choose_your_size']
    }
  },
  methods: {
    scrollToGeometry() {
      document.getElementById('geometry-table').scrollIntoView({
        behavior: 'smooth'
      });
      this.$root.$emit('onScrollToGeometry')
    },
    reset() {
      this.$store.commit('build/setSelectorLoading', true)

      let preselected = {...this.preselected}

      preselected.size.selected = null

      preselected.model.completed = true
      preselected.model.active = false
      preselected.title.active = false
      preselected.title.completed = true
      // preselected.brakes.active = false
      // preselected.brakes.completed = true
      preselected.color.active = false
      preselected.color.completed = true
      preselected.size.active = true
      preselected.size.completed = false

      this.$store.commit('build/setPreselected', {...this.preselected, ...preselected})


      this.$store.dispatch('build/updatePreselected').then(ps => {
        this.$store.commit('build/setSelectorLoading', false)
        this.$store.commit('build/setPreselected', {...this.preselected, ...ps})

        history.pushState({}, "", `${location.origin}/en/choose/${this.preselected.model.selected.slug}/${this.preselected.title.selected.slug}/${this.preselected.brakes.color.slug}`)
        // history.pushState({}, "", `${location.origin}/en/choose/${this.preselected.model.selected.slug}/${this.preselected.title.selected.slug}/${this.preselected.brakes.selected.slug}/${this.preselected.brakes.color.slug}`)
      })
    },
    selectSize(size) {
      this.$store.commit('build/setSelectedSize', size)
      // this.$root.$emit('sizeChanged')
    },
    isSelected(size) {
      return this.selectedSize !== null && this.selectedSize.id === size.id
    },
    sizeOptionClass(size) {
      return {
        active: this.isSelected(size)
      }
    },
    confirmSelected() {
      this.$store.commit('build/setSelectorLoading', true)

      this.$store.dispatch('build/updatePreselected').then(ps => {
        this.$store.commit('build/setSelectorLoading', false)
        this.$store.commit('build/setPreselected', {...this.preselected, ...ps})

        history.pushState({}, "", `${location.origin}${window.removeTrailingSlash(location.pathname)}/${this.preselected.size.selected.slug}`)
      })

      // this.loading = true
      // this.$store.dispatch('build/selectSize', {
      //   path: this.$path,
      //   model: this.selectedModel
      // }).then(() => {
      //   this.$emit('onConfirmed')
      // }).finally(() => {
      //   this.loading = false
      // })
    }
  },
}
</script>
